var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.31 8.58s.238 1.183.483 1.963c.178.566.377 1.147.407 1.345.071.47.103.587.116.613l.003.004-1.491.82s-.643-.963-.964-1.686c-.322-.726-.967-3.06-.967-3.06zM12.635 0C12.961 0 14 .772 14 .772V12.36s-1.039.772-1.365.772c-.29 0-.226-.165-.485-.29-.998-.482-1.376-2.547-3.473-3.379-.83-.329-2.934-.934-2.934-.934l-4.44.051S0 8.014 0 7.531V5.6c0-.483 1.303-1.048 1.303-1.048l4.44.05s2.104-.604 2.934-.933c2.097-.832 2.475-2.897 3.473-3.38.26-.124.195-.289.485-.289"
})));
export default SvgVkMobileShare;